import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { FirebaseApp } from "./auth"
import vuetify from "./plugins/vuetify";
import ApiService from "./services/api.service";
import _ from 'lodash';
import LoadScript from 'vue-plugin-load-script'

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");

const moment = require('moment')
require('moment/locale/pt')
Vue.use(require('vue-moment'), {
  moment
})

Vue.prototype.$auth = FirebaseApp.auth();
Vue.prototype.$lodash = _;
Vue.use(LoadScript);

FirebaseApp.auth().onAuthStateChanged(function (user) {
  if (user) {
    if (user.emailVerified) {
      user.getIdTokenResult(true)
        .then(idTokenResult => {
          localStorage.setItem("token", idTokenResult.token);
          if(idTokenResult.claims.roles) {
            store.commit("setAdmin", idTokenResult.claims.roles.includes("ADMIN"));
            store.commit("setPremium", idTokenResult.claims.roles.includes("BIGODDS_PREMIUM"));
            store.commit("setModerator", idTokenResult.claims.roles.includes("MODERATOR"));
          }
        });

      // Is authenticated
      store.commit("setAuthenticated", true);

      ApiService.getUser().then(
        response => {
          // Is authorized
          store.commit("setUser", response.data);
        },
        error => {
          console.log(
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
          );
        }
      );
    }
    // ...
  } else {
    //router.replace("/login");
    //console.log("logged out2")
  }
});